import { CookieKeys, getCookie } from 'services/Cookies'

export const getVisitorId = () => {
  if (typeof window === 'undefined') return

  const visitorId = getCookie(CookieKeys._VID)
    ? JSON.parse(decodeURIComponent(getCookie(CookieKeys._VID) || '')).value
    : undefined;

  return visitorId ?? undefined
}
